module.exports = __webpack_public_path__ + "img/storeVisit_bg.3172c8b9.png";